<input
  class="form-control"
  type="text"
  mask="000.000.000-00"
  placeholder="000.000.000-00"
  [dropSpecialCharacters]="false"
  [formControl]="formControl"
  [formlyAttributes]="field"
/>
